// src/Config/dexieDB.js
import Dexie from "dexie";

const db = new Dexie("AppDatabase");

db.version(1).stores({
  userInfo: "++id",
  profiles: "++id",
  userProfile: "++id",
  payments: "++id",
  farmer_bundle: "++id",
  vegetable_bundle: "++id",
  zone: "++id",
  village: "++id",
  objective: "++id",
  objective_ludewa: "++id",
  farmers: "++id",
  farmer_list: "++id",
  zone_nutritional_coordinator: "++id",
  offlineFarmers:
    "++id, uuid, name, gender, village_id, phone, created_at, synced",
  offlineBundles: "++id, farmer_id, bundle_id, amount, created_at, synced",
});

export default db;
